





















import Vue from 'vue';
import LabelList from './LabelList.vue';
import { setScroll } from '../../utils';

export default Vue.extend({
  name: 'searchPanel',
  components: {
    LabelList
  },
  data() {
    return {
      showMore: false,
      overflowValue: 'hidden',
      height: 'auto'
    };
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    row: {
      type: Number,
      default: 2
    }
  },
  methods: {
    onSelect(val: string) {
      setScroll();
      this.$emit('onSelect', val);
    },
    onDelete() {
      this.$emit('onDelete');
    },
    clickMore() {
      this.showMore = false;
      this.height = 'unset';
      this.overflowValue = 'visible';
    },
    handleHeightChange(newVal: string) {
      const limitHeight = this.row * 45;

      if (Number.parseInt(newVal, 0) > limitHeight) {
        this.showMore = true;
        this.height = `${limitHeight}px`;
        this.overflowValue = 'hidden';
      }
    }
  }
});
